import { useEffect, useMemo, useRef } from 'react';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import { useEffectOnce } from 'react-use';
import { playSound, Sound } from '~/assets/sounds';
import { rage, useObservable } from '~/rage';
import { Layouts } from '~/shared';
import { Modal } from '../../components/Modal';
import { AppList } from '../../components/TabletAppList';
import { TabletTopRow } from '../../components/TabletTopRow';
import { useShake } from '../../hooks';
import {
	setActiveApp,
	useLayoutDispatch,
	useLayoutSelector,
} from '../../redux';
import {
	StyledButtons,
	StyledContainer,
	StyledScreenContainer,
	StyledTabletTopContainer,
} from './Tablet.styled';

const Tablet = () => {
	const dispatch = useLayoutDispatch();
	const activeApp = useLayoutSelector((state) => state.tablet.activeApp);
	const sdkActiveApp = useObservable(rage.tablet.getActiveApp());
	const { isShaking } = useShake();
	const isVisible = useObservable(
		rage.gui.getLayoutVisibleState(Layouts.Tablet),
	);
	const closeSoundPlayedRef = useRef(false);

	const ActiveAppComponent = useMemo(() => AppList[activeApp], [activeApp]);

	useEffect(() => {
		if (sdkActiveApp) {
			dispatch(setActiveApp(sdkActiveApp));
		}
	}, [sdkActiveApp]);

	useEffect(() => {
		if (isVisible === false && !closeSoundPlayedRef.current) {
			playSound(Sound.LockPad);
			closeSoundPlayedRef.current = true;
		}
	}, [isVisible]);

	useEffectOnce(() => {
		playSound(Sound.UnlockPad);
	});

	return (
		<StyledContainer className={Layouts.Tablet} $isShaking={isShaking}>
			<StyledButtons />
			<StyledScreenContainer>
				<StyledTabletTopContainer>
					<TabletTopRow />
				</StyledTabletTopContainer>
				<SwitchTransition>
					<CSSTransition
						key={activeApp}
						timeout={300}
						classNames={'app'}
						addEndListener={(node, done) =>
							node.addEventListener('transitionend', done, false)
						}
					>
						{ActiveAppComponent && <ActiveAppComponent />}
					</CSSTransition>
				</SwitchTransition>
				<Modal />
			</StyledScreenContainer>
		</StyledContainer>
	);
};

export { Tablet };
